var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomLeftBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 334,
    viewBox: "0 0 257 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.911 103.099L99.6947 324.843C89.5659 339.502 70.3238 344.69 54.1991 337.109L-16.3354 303.947C-28.9515 298.015 -33.3286 282.245 -25.5742 270.659L4.54874 225.656L33.4544 182.471C41.1264 180.538 49.3184 178.041 57.7302 175.009C94.4224 161.785 121.401 143.389 117.988 133.92C114.576 124.451 82.0641 127.495 45.3718 140.719C36.4071 143.95 28.0224 147.49 20.5186 151.133L-77.5577 125.657C-90.9388 122.181 -98.1643 107.684 -92.8836 94.9068L-63.2046 23.0927C-56.2781 6.33318 -38.0846 -2.78532 -20.5124 1.69556L239.798 68.0747C255.175 71.9957 261.932 90.0435 252.911 103.099Z",
    fill: "#52DEE5",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeftBg);
export default __webpack_public_path__ + "static/media/bottomLeftBg.4639359c863d1117b05c99cdec5272fb.svg";
export { ForwardRef as ReactComponent };